<template>
  <v-form ref="form">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          clearable
          :disabled="readOnly"
        />
      </v-col>
      <v-col cols="12" sm="4">

        <v-switch label="Gera movimentação" v-model="entry.move">
          
        </v-switch>
      </v-col>
      <v-col cols="12" sm="4">

        <v-switch label="Gera financeiro" v-model="entry.bill">
          
        </v-switch>
      </v-col>

      <v-col cols="12" sm="4">

        <v-switch label="Saída" v-model="entry.out">
          
        </v-switch>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <v-autocomplete v-model="entry.purpose" v-bind="getObject('purpose')" label="Propósito"
          :items="extraData.adminContext.cfopPurposes" item-value="id" item-text="name"
          autocomplete="off" />
      </v-col>

      <v-col cols="12" sm="4">

        <v-switch label="Verificado" v-model="entry.verified">
          
        </v-switch>
      </v-col>


    </v-row>
  </v-form>
</template>

<script>
import gql from 'graphql-tag';
// import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      loadingNcms: false,
      ncmId: null,
      ncmSearch: null,
      ncmSearchTimeout: null,
      itemsSearchTimeout: null,
      pageLoading: false,
      subCulturesList:[],
      subCulturesListLoading: false,
      fertilizersList:[],
      fertilizersListLoading: false,
      partsList:[],
      partsListLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    // MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  watch: {
    ncmSearch: {
      // immediate: true,
      handler(val, oldVal) {

        // Items have already been requested
        // if (this.loadingNcms) {
        //   return;
        // }
        // console.log("this.entry.ncm: ", this.entry.ncm)
        // console.log("val:" + val)

        if (val == "" || (val && val.length < 3)) {
          return;
        }

        if (this.entry.ncm && this.entry.ncm.text == val){
          return;
        }

        clearTimeout(this.ncmSearchTimeout);
        this.ncmSearchTimeout = setTimeout(() => {
          this.loadNcmsList(val);
        }, 500);
      }
    },
    'entry.itemType': {
      handler(old, oldVal){
        // console.log("changed");
        // console.log("en", this.entry);
        if(this.entry.itemType == 'Fertilizer'){
          this.loadFertilizersList();
        }

        if(this.entry.itemType == 'Part'){
          this.loadPartsList();
        }
      }
    },
    'entry.cultureIdsAttributes': {
      handler(old, oldVal){
        this.loadSubCulturesList();
      }
    },
  },
  created() {
    this.setupEntryAttributes(this.entry, this.entryAttributes);
    if(this.entry.itemType == 'Fertilizer'){
      this.loadFertilizersList();
    }
    if(this.entry.cultureIdsAttributes){
      this.loadSubCulturesList();
    }
    if(this.entry.itemType == 'Part'){
      this.loadPartsList();
    }
    // this.entry.itemIdsAttributes=[];
  },
  methods: {
    selectNcm: function() {
      this.entry.ncm = this.extraData.allAvailableNcms.find(obj => obj.id == this.entry.ncmId);
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    
  }
};

const ALL_AVAILABLE_NCMS_QUERY = gql `
  query($taxationGroupId: ID, $query: String) {
    globalContext {
      allAvailableNcms(taxationGroupId: $taxationGroupId, query: $query) {
        id
        text
      }
    }
  }
`;

const ALL_SUB_CULTURES_QUERY = gql `
  query($cultureIds: [ID!]!){
    globalContext {
      allSubCulturesForCulture(cultureIds: $cultureIds) {
        id
        name
        additionalInfo
      }
    }
  }
`;

const ALL_FERTILIZERS_QUERY = gql `
  {
    globalContext {
      allFertilizers {
        id
        name
        text
        additionalInfo
      }
    }
  }
`;

const ALL_PARTS_QUERY = gql `
  {
    globalContext {
      allParts {
        id
        name
        additionalInfoForGroupTaxes
        additionalInfo
      }
    }
  }
`;

</script>

<style scoped></style>
